import { amountHelper } from './amountHelper'
import { SboCurrency } from './SboCurrency'

type PartialProps<T> = Partial<T>
export class Amount {
    public value: number
    private readonly currency: string

    constructor(value: number, currency?: string) {
        this.value = value
        this.currency = currency ?? ''
    }

    get label(): string {
        return this.value === 0 ? '' : amountHelper.getLocaleString(this.value, this.currency)
    }

    set label(newAmount: string) {
        this.value = this.parseLabel(newAmount)
    }

    static createBySboAmount(sboAmount: number, currency: SboCurrency) {
        return new SboCurrency(currency).isKAmount()
            ? new Amount(sboAmount * 1000, currency.toString())
            : new Amount(sboAmount, currency.toString())
    }

    public toCurrencyString(): string {
        return amountHelper.getLocaleStringWithSymbol(this.value, this.currency)
    }

    public getCurrency(): string {
        return this.currency
    }

    private parseLabel(amount: string): number {
        const decimalSign = amountHelper.getLocaleDecimalSign(this.currency)
        const amountString = amount.replace(new RegExp(`[^${decimalSign}\\d]`, 'g'), '').replace(decimalSign, '.')
        return Number(amountString)
    }
}

export class AmountRange {
    minAmount: Amount = new Amount(0)
    maxAmount: Amount = new Amount(0)

    constructor(data: PartialProps<AmountRange> = {}) {
        Object.assign(this, data)
    }
}
